import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography, TextField, Button } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

const StatusModal = ({
	isOpen,
	onClose,
	title,
	message = '',
	billStatus,
	onYesClick,
	loading,
	data,
	retrictedAmount,
	id,
}) => {
	const [remark, setRemark] = useState('');
	const [error, setError] = useState('');
	const [errorRemark, setErrorRemark] = useState('');
	const [requestAmount, setRequestAmount] = useState(data);

	// Reset remark and error when modal closes
	useEffect(() => {
		if (!isOpen) {
			setRemark('');
			setErrorRemark('');
			setError('');
		}
	}, [isOpen]);

	// Update amount when data changes
	useEffect(() => {
		// console.log(data);
		if (data !== undefined && data !== null) {
			setRequestAmount(data.toString());
		}
	}, [data]);

	const handleApprove = () => {
		const tripAdvanceRequest = parseFloat(requestAmount) || 0;
		const restrictAmount = parseFloat(retrictedAmount) || 0;
		if (tripAdvanceRequest === '' || tripAdvanceRequest === 0) {
			setError(`Value cannot be zero. Please enter a valid amount.`);
			return false;
		} else if (remark === '' || remark === 0) {
			setErrorRemark(`Enter the reason.`);
			return false;
		} else if (tripAdvanceRequest > restrictAmount) {
			// console.log(tripAdvanceRequest ,restrictAmount)
			setError(
				`Unable to send request since the amount exceeds the limit of ${restrictAmount}.`
			);

			return false;
		} else {
			setErrorRemark('');
			setError('');
			onYesClick(requestAmount, remark, id); // Trigger approve
		}
	};

	const handleAmountChange = (e) => {
		let value = e.target.value;

		// Prevent leading zeros
		if (value.startsWith('0')) {
			value = value.replace(/^0+/, '');
		}

		setRequestAmount(value);

		const tripAdvance = parseFloat(value) || 0;
		const restrictAmount = parseFloat(retrictedAmount) || 0;

		if (value === '' || tripAdvance === 0) {
			setError('Value cannot be zero. Please enter a valid amount.');
			return;
		}

		if (tripAdvance > restrictAmount) {
			setError(`Amount exceeds limit of ${restrictAmount}.`);
			return;
		}

		setError('');
	};

	return (
		<div>
			{/* Main Modal */}
			<Modal open={isOpen} onClose={onClose}>
				<Box
					sx={{
						position: 'absolute',
						top: '50%',
						left: '50%',
						transform: 'translate(-50%, -50%)',
						bgcolor: 'background.paper',
						boxShadow: 24,
						p: 4,
						width: 400,
						borderRadius: 2,
					}}
				>
					{/* Header */}
					<Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
						<Typography variant="h6">{title}</Typography>
						<button
							onClick={onClose}
							style={{
								background: 'transparent',
								border: 'none',
								fontSize: '20px',
								cursor: 'pointer',
							}}
							aria-label="Close"
						>
							✕
						</button>
					</Box>

					{/* Input Field */}
			<TextField
  type="text"
  value={requestAmount}
  onChange={(e) => {
    const value = e.target.value;
    // Remove any non-numeric characters (allow decimal point)
    const numericValue = value.replace(/[^0-9.]/g, '');
    handleAmountChange({ target: { value: numericValue } });
  }}
  label="Enter Approval Amount"
  fullWidth
  variant="outlined"
  error={Boolean(error)}
  helperText={error}
  sx={{ marginBottom: 2 }}
/>

					<TextField
						value={remark}
						inputProps={{ maxLength: 200 }}
						onChange={(e) => setRemark(e.target.value)}
						label="Reason"
						fullWidth
						variant="outlined"
						error={Boolean(errorRemark)}
						helperText={errorRemark}
						sx={{ marginTop: 2 }}
					/>

					{/* Message */}
					{message && (
						<Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
							{message}
						</Typography>
					)}

					{/* Actions */}
					<Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
						{loading ? (
							<CircularProgress size={24} />
						) : (
							<>
								<Button
									variant="text"
									onClick={onClose}
									sx={{ color: 'red', mr: 2 }}
								>
									Cancel
								</Button>
								<Button
									variant="text"
									onClick={handleApprove}
									sx={{ color: 'green' }}
									disabled={billStatus === 'loss'}
								>
									Re-Request
								</Button>
							</>
						)}
					</Box>
				</Box>
			</Modal>
		</div>
	);
};

export default React.memo(StatusModal);
